import { Scenario, ScenarioType } from "@/app/lib/types";

const animalEmojiMap: Record<string, string> = {
  canine: "🐕",
  feline: "🐈",
  equine: "🐎",
  bovine: "🐄",
  ovine: "🐑",
};

export function getScenarioEmoji(scenario: Scenario): string {
  if (scenario.scenarioType === ScenarioType.Animal && scenario.animalDetails?.patientSpecies) {
    return animalEmojiMap[scenario.animalDetails.patientSpecies.toLowerCase()] || "🐾";
  }
  return "👤";
}